<template lang="html">
  <div class="editorPage">
    <div class="editor" id="editor">
    <div ref="toolbar" class="toolbar">
    </div>
    <div ref="editor" class="text">
    </div>
  </div>
  <el-dialog
    @close="beforeClose"
    title="预览"
    :visible.sync="dialogVisible"
    top="5vh"
    width="1000px">
      <div class="previewBox" v-html="value"></div> 
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible=false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import config from "@/config/env";
  import $ from 'jquery'
  import E from 'wangeditor'
  export default {
    name: 'editoritem',
    data() {
      return {
        editor: null,
        info_: null,
        dialogVisible:false,
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      isClear: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      isClear(val) {
        // 触发清除文本域内容
        if (val) {
          this.editor.txt.clear()
          this.info_ = null
        }
      },
      value: function(value) {
        if (value !== this.editor.txt.html()) {
          this.editor.txt.html(this.value)
        }
      }
      //value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
    },
    mounted() {
      let self = this
      this.seteditor()
      this.editor.txt.html(this.value)
      $(document).off("click", ".fullscreen-btn").on('click', ".fullscreen-btn", function () {
      　　var $this = $(this);
      　　var isActive = $this.hasClass('active');
      　　if (!isActive) {
              $(".editor").addClass('fullscreen')
      　　　　$this.addClass('active');
      　　}else{
            $(".editor").removeClass('fullscreen')
             $this.removeClass('active');
      }
      })
      $(document).off("click", ".look-btn").on('click', ".look-btn", function () {
      　　self.dialogVisible=true
      })
    },
    methods: {
      beforeClose(){

      },
      seteditor() {
        // this.editor.config.menuFixed = false;
        this.editor = new E(this.$refs.toolbar, this.$refs.editor)
        this.editor.customConfig.uploadImgShowBase64 = false // base 64 存储图片
        this.editor.customConfig.uploadImgServer = window.g.host+'/oss/img'// 配置服务器端地址
        this.editor.customConfig.uploadImgHeaders = { }// 自定义 header
        this.editor.customConfig.uploadFileName = 'file' // 后端接受上传文件的参数名
        this.editor.customConfig.uploadImgMaxSize = 20 * 1024 * 1024 // 将图片大小限制为 20M
        this.editor.customConfig.uploadImgMaxLength = 6 // 限制一次最多上传 3 张图片
        this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000 // 设置超时时间
        this.editor.customConfig.uploadImgParams = {
            target: 'file'
        }
        this.editor.customConfig.fontName=['微软雅黑']
        // 配置菜单
        this.editor.customConfig.menus = [
          'head', // 标题
          'bold', // 粗体
          'fontSize', // 字号
          'fontName', // 字体
          'italic', // 斜体
          'underline', // 下划线
          'strikeThrough', // 删除线
          'foreColor', // 文字颜色
          'backColor', // 背景颜色
          'link', // 插入链接
          'list', // 列表
          'justify', // 对齐方式
          // 'quote', // 引用
          // 'emoticon', // 表情
          'image', // 插入图片
          'table', // 表格
          'video', // 插入视频
          'code', // 插入代码
          'undo', // 撤销
          'redo', // 重复
          'fullscreen' // 全屏
        ]
        // this.editor.config.familys = ["微软雅黑"];
        this.editor.customConfig.fontNames = ['宋体','微软雅黑']
        this.editor.customConfig.uploadImgHooks = {
          fail: (xhr, editor, result) => {
            // 插入图片失败回调
          },
          success: (xhr, editor, result) => {
            // 图片上传成功回调
          },
          timeout: (xhr, editor) => {
            // 网络超时的回调
          },
          error: (xhr, editor) => {
            // 图片上传错误的回调
          },
          customInsert: (insertImg, result, editor) => {
            // 图片上传成功，插入图片的回调
              let url = result.data.src
              insertImg(url)
          }
        }
        this.editor.customConfig.customUploadImg = (files, insert) => {
            for(var i = 0;i < files.length;i ++) {
                let formData = new FormData();
                formData.append("file", files[i]); 
                formData.append("target", 'file'); 
                axios.post(window.g.host+'/oss/img', formData, {     // 上传图片接口
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                }).then(res => {
                  console.log(res)
                      if(res.data.code == 200){
                           insert(res.data.data.src);
                      }else{
                            this.$message.error(res.data.msg);
                            return;
                      }
                })
            }
            
        };
        this.editor.customConfig.onchange = (html) => {
          this.info_ = html // 绑定当前逐渐地值
          this.$emit('change', this.info_) // 将内容同步到父组件中
        }
        // 创建富文本编辑器
        this.editor.create()
         $(".toolbar").append('<div class="w-e-menu"><a class="fullscreen-btn"></a></div>')
         $(".toolbar").append('<div class="w-e-menu"><a class="look-btn"></a></div>')
      },
    }
  }
</script>

<style lang="css">
  .editorPage .el-form-item__content{
    line-height: 36px;
  }
  .editor {
    margin: 0 auto;
    position: relative;
    z-index: 0;
    background: #fff;
  }
  .fullscreen{
    position: fixed;
    left: 235px;
    right: 10px;
    top: 105px;
    bottom: 5px;
    z-index: 1;
  }
  .fullscreen .text{
    height: 100%;
  }
  .toolbar {
    border: 1px solid #ccc;
  }
  .text {
    border: 1px solid #ccc;
    height: 600px;
    overflow-y: auto;
  }
  .fullscreen-btn{
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url('../../assets/img/fullscreen3.png') no-repeat;
    background-size: contain;
    vertical-align: middle;
  }
  .fullscreen-btn:hover{
    background: url('../../assets/img/fullscreen.png') no-repeat;
    background-size: contain;
  }
  .fullscreen-btn.active{
    background: url('../../assets/img/fullscreen2.png') no-repeat;
    background-size: contain;
  }
  .look-btn{
    display: inline-block;
    width: 16px;
    height: 16px;
    background: url('../../assets/img/look3.png') no-repeat;
    background-size: contain;
    vertical-align: middle;
  }
  .look-btn:hover{
    background: url('../../assets/img/look.png') no-repeat;
    background-size: contain;
  }
  .look-btn.active{
    background: url('../../assets/img/look2.png') no-repeat;
    background-size: contain;
  }
  .previewBox{
    height: 70vh;
    overflow-y: auto;
    
  }
  .w-e-text {
    min-height: 500px;
  }
.couponAdd .text{
  height: 200px;
  width: 800px;
}
.couponAdd .toolbar{
  width: 800px;
}
.couponAdd .w-e-text{
  min-height: 200px !important;
}
</style>